/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of AOMGH5PageInitPlugin
 */

import { ITrackedEvent } from 'com/didichuxing/tracker/event/ITrackedEvent';
import { ITrackedEventArgs } from 'com/didichuxing/tracker/plugin/IReportingStrategyPlugin';
import OMGH5PageInitEvent from 'com/didichuxing/tracker/events/OMGH5PageInitEvent';
import AReportingStrategyPlugin from 'com/didichuxing/tracker/plugin/AReportingStrategyPlugin';
import PluginUtils from 'com/didichuxing/tracker/plugin/utils/PluginUtils';

export default abstract class AOMGH5PageInitPlugin extends AReportingStrategyPlugin {

    /**
     * @override
     * @inheritDoc
     * @returns {boolean}
     */
    public install(): boolean {
        const context: any = this.getContext();
        // 加入配置不发送请求
        if (context && context.disabledInit) {
            return super.install();
        }
        const attrs  = {
            trackerVersion: this.getContext().version
        };
        /**
         * - 加入XSpm的参数
         */
        try {
            if (context && context.getXspmAttrs) {
                const xspmAttrs = context.getXspmAttrs();
                Object.assign(attrs, xspmAttrs);
            }
        } catch (error) {
            console.info('合并xspm参数失败');
        }
        this.report({
            eventId: PluginUtils.EVENT_ID_PAGE_INIT,
            attrs
        });
        return super.install();
    }

    /**
     * @override
     * @returns {string}
     */
    public getName(): string {
        return PluginUtils.PLUGIN_NAME_PAGE_INIT;
    }

    /**
     * @override
     * @inheritDoc
     */
    public execute(): void {
        /* Nothing to exit */
    }

    /**
     * @override
     * @inheritDoc
     */
    public exit(): void {
        /* Nothing to exit */
    }

    /**
     * @override
     * @inheritDoc
     * @param {ITrackedEventArgs} eventArgs
     * @returns {ITrackedEvent}
     */
    protected generateEvent(eventArgs: ITrackedEventArgs): ITrackedEvent {
        return new OMGH5PageInitEvent(eventArgs.attrs, this.getContext());
    }
}
